import type { SelectOption } from '@atlassian/jira-common-components-picker';
import { MAX_RESULTS } from '../rest';
import type { ComponentsResponse, SingleComponentResponse } from '../rest/types';
import type { SingleComponent } from '../types';

const transformOption = (component: SingleComponentResponse): SelectOption => ({
	value: component.id,
	label: component.name,
});

export const transformToComponent = ({ id, name }: SingleComponentResponse): SingleComponent => ({
	id,
	name,
});

export const transformToOptions = (data: ComponentsResponse, ignore: string[]): SelectOption[] => {
	const { values } = data;
	return values
		.filter((value) => !ignore.includes(value.id))
		.map(transformOption)
		.slice(0, MAX_RESULTS);
};
